import * as React from 'react';
import { MediaQuery, Modal, Card } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { Footer } from '../modules/Footer/Footer.js';
import { ShippingMethodsListContainer } from '../StepShipping/modules/ShippingMethods/containers/ShippingMethodsListContainer.js';
import { SelectedShippingMethodContainer } from '../StepShipping/modules/ShippingMethods/containers/SelectedShippingMethodContainer.js';
import { EditableAddressesSummary } from './EditableSummaries/EditableAddressesSummary.js';
import { EditableContactDetailsSummary } from './EditableSummaries/EditableContactDetailsSummary.js';
import { EditableInvoiceSummary } from './EditableSummaries/EditableInvoiceSummary.js';
import { EditableCompanySummary } from './EditableSummaries/EditableCompanySummary.js';
import { ServiceStore } from '../modules/ServiceStore/layout/ServiceStore.js';
import { EditableLoyaltyPointsSummary } from './EditableSummaries/EditableLoyaltyPointsSummary.js';
import { StepNames } from '../models/shared.js';
import { getShippingMethodInfo } from '../utils/get-shipping-method-info.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';

const StepOverview = ({ isPickupStore , isPickupPoint , labels , onEdit , onNextClick , onPrevClick , selectedStore , shippingMethodsAsides , serviceStore , selectedPickupPoint , shippingMethod , cartComponent ,  })=>{
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { getLabel  } = useIntl();
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const shippingMethodInfo = getShippingMethodInfo(labels.summary, shippingMethod, shippingMethodsAsides);
    const { features  } = useCheckoutSettings();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        title: labels.completed.shipmentDetailsDelivery,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        isOpen: isModalOpen
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--overview__delivery-methods"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        onChange: ()=>setIsModalOpen(false)
        ,
        asides: shippingMethodsAsides
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--overview"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--overview card--colapse-borders"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.yourDetails), /*#__PURE__*/ React.createElement(Card, {
        className: "checkout-card__reset-bottom-border-radius"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, onEdit && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: ()=>setIsModalOpen(true)
        ,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "checkout-step--overview__caption"
    }, labels.completed.shipmentDetailsDelivery), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, shippingMethodInfo.label, " ", shippingMethodInfo.aside && shippingMethodInfo.aside, isPickupStore && !selectedStore && /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        warningMessageOnly: true
    }), isPickupPoint && !selectedPickupPoint && /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        warningMessageOnly: true
    })))), isPickupStore && selectedStore && /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        hideTitle: true
    }), isPickupPoint && selectedPickupPoint && /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        hideTitle: true
    }), /*#__PURE__*/ React.createElement(EditableAddressesSummary, {
        labels: labels
    }), /*#__PURE__*/ React.createElement(EditableContactDetailsSummary, {
        labels: labels
    }), /*#__PURE__*/ React.createElement(EditableInvoiceSummary, {
        labels: labels
    }), /*#__PURE__*/ React.createElement(EditableCompanySummary, {
        labels: labels
    }), (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && serviceStore && !isPickupStore && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ServiceStore, {
        className: "checkout-card__reset-border-radius"
    })), /*#__PURE__*/ React.createElement(EditableLoyaltyPointsSummary, null), isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--overview__cart"
    }, cartComponent), /*#__PURE__*/ React.createElement(Footer, {
        stepName: StepNames.Overview,
        onPrevStep: onPrevClick,
        onNextStep: onNextClick
    }))));
};

export { StepOverview };
//# sourceMappingURL=StepOverview.js.map
